<div class="overlapping-spinner-container">
  <p-progressspinner ariaLabel="loading" />
</div>
